// Auto-generated by generate-rtdb-wrappers.js
import { useDocument } from "./firestoreBaseApi";
import {
    createRtdbDocumentApi,
    rtdbPaths,
    useRtdbDocuments,
} from "./rtdbBaseApi";

// ---- DroneConnection Resources ----

export function DroneConnectionRtdbDocument(droneId) {
    return createRtdbDocumentApi(rtdbPaths.droneConnectionDocument)(droneId);
}

/**
 * Hook for subscribing to or once-fetching a single DroneConnection document.
 *
 * @param droneId
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneConnectionRtdbDocument(droneId, options) {
    return useDocument(DroneConnectionRtdbDocument, [droneId], options);
}

/**
 * Hook for subscribing to or once-fetching multiple DroneConnection documents.
 *
 * @param droneIds Array of droneId values
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneConnectionRtdbDocuments(droneIds = [], options = {}) {
    return useRtdbDocuments(DroneConnectionRtdbDocument, droneIds, [], options);
}

// ---- DroneErrors Resources ----

export function DroneErrorsRtdbDocument(droneId) {
    return createRtdbDocumentApi(rtdbPaths.droneErrorsDocument)(droneId);
}

/**
 * Hook for subscribing to or once-fetching a single DroneErrors document.
 *
 * @param droneId
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneErrorsRtdbDocument(droneId, options) {
    return useDocument(DroneErrorsRtdbDocument, [droneId], options);
}

/**
 * Hook for subscribing to or once-fetching multiple DroneErrors documents.
 *
 * @param droneIds Array of droneId values
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneErrorsRtdbDocuments(droneIds = [], options = {}) {
    return useRtdbDocuments(DroneErrorsRtdbDocument, droneIds, [], options);
}

// ---- DroneMissions Resources ----

export function DroneMissionsRtdbDocument(droneId) {
    return createRtdbDocumentApi(rtdbPaths.droneMissionsDocument)(droneId);
}

/**
 * Hook for subscribing to or once-fetching a single DroneMissions document.
 *
 * @param droneId
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneMissionsRtdbDocument(droneId, options) {
    return useDocument(DroneMissionsRtdbDocument, [droneId], options);
}

/**
 * Hook for subscribing to or once-fetching multiple DroneMissions documents.
 *
 * @param droneIds Array of droneId values
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneMissionsRtdbDocuments(droneIds = [], options = {}) {
    return useRtdbDocuments(DroneMissionsRtdbDocument, droneIds, [], options);
}

// ---- DroneState Resources ----

export function DroneStateRtdbDocument(droneId) {
    return createRtdbDocumentApi(rtdbPaths.droneStateDocument)(droneId);
}

/**
 * Hook for subscribing to or once-fetching a single DroneState document.
 *
 * @param droneId
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneStateRtdbDocument(droneId, options) {
    return useDocument(DroneStateRtdbDocument, [droneId], options);
}

/**
 * Hook for subscribing to or once-fetching multiple DroneState documents.
 *
 * @param droneIds Array of droneId values
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneStateRtdbDocuments(droneIds = [], options = {}) {
    return useRtdbDocuments(DroneStateRtdbDocument, droneIds, [], options);
}

// ---- DroneWidget Resources ----

export function DroneWidgetRtdbDocument(droneId, widgetName) {
    return createRtdbDocumentApi(rtdbPaths.droneWidgetDocument)(
        droneId,
        widgetName,
    );
}

/**
 * Hook for subscribing to or once-fetching a single DroneWidget document.
 *
 * @param droneId
 * @param widgetName
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneWidgetRtdbDocument(droneId, widgetName, options) {
    return useDocument(DroneWidgetRtdbDocument, [droneId, widgetName], options);
}

/**
 * Hook for subscribing to or once-fetching multiple DroneWidget documents.
 *
 * @param droneIds Array of droneId values
 * @param widgetName
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneWidgetRtdbDocuments(
    droneIds = [],
    widgetName,
    options = {},
) {
    return useRtdbDocuments(
        DroneWidgetRtdbDocument,
        droneIds,
        [widgetName],
        options,
    );
}

// ---- DroneWidgetData Resources ----

export function DroneWidgetDataRtdbDocument(droneId, widgetName) {
    return createRtdbDocumentApi(rtdbPaths.droneWidgetDataDocument)(
        droneId,
        widgetName,
    );
}

/**
 * Hook for subscribing to or once-fetching a single DroneWidgetData document.
 *
 * @param droneId
 * @param widgetName
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneWidgetDataRtdbDocument(droneId, widgetName, options) {
    return useDocument(
        DroneWidgetDataRtdbDocument,
        [droneId, widgetName],
        options,
    );
}

/**
 * Hook for subscribing to or once-fetching multiple DroneWidgetData documents.
 *
 * @param droneIds Array of droneId values
 * @param widgetName
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneWidgetDataRtdbDocuments(
    droneIds = [],
    widgetName,
    options = {},
) {
    return useRtdbDocuments(
        DroneWidgetDataRtdbDocument,
        droneIds,
        [widgetName],
        options,
    );
}

// ---- DroneWidgets Resources ----

export function DroneWidgetsRtdbDocument(droneId) {
    return createRtdbDocumentApi(rtdbPaths.droneWidgetsDocument)(droneId);
}

/**
 * Hook for subscribing to or once-fetching a single DroneWidgets document.
 *
 * @param droneId
 * @param options.mode 'live' (default) or 'once'
 */
export function useDroneWidgetsRtdbDocument(droneId, options) {
    return useDocument(DroneWidgetsRtdbDocument, [droneId], options);
}

/**
 * Hook for subscribing to or once-fetching multiple DroneWidgets documents.
 *
 * @param droneIds Array of droneId values
 * @param options.mode 'live' (default) or 'once'
 * @param options.type 'list' (default) or 'map'
 */
export function useDroneWidgetsRtdbDocuments(droneIds = [], options = {}) {
    return useRtdbDocuments(DroneWidgetsRtdbDocument, droneIds, [], options);
}
